exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mobileElementGroup_5gee9ju6XVNMat1hezoEU {\n  width: calc(100% + 10px);\n  padding-left: 35px;\n  padding-right: 20px;\n  padding-top: 20px;\n  overflow: hidden;\n  float: left;\n  clear: both;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"mobileElementGroup": "mobileElementGroup_5gee9ju6XVNMat1hezoEU"
};